import { APIError, ErrorLog } from 'utils/LoggerItem';

export function createConstants(...constants) {
  return constants.reduce(
    (acc, constant) => ({
      ...acc,
      [constant]: constant,
    }),
    {},
  );
}
// Helper function for creating reducers (to reduce boilerplate)
export function createReducer(initialState, reducerMap) {
  return (state = initialState, action) => {
    const reducer = reducerMap[action.type];
    return reducer ? reducer(state, action.payload) : state;
  };
}

export function repeatText(text, times) {
  const msgList = [];
  for (let i = 0; i < times; i += 1) {
    msgList.push(text);
  }
  return msgList.join(' ');
}
// Turn into an object with .reduce()
export const arrayToObject = (array, id) => array.reduce((accumulator, current) => {
  accumulator[current[id]] = current;
  return accumulator;
}, {});

export function DOMRectToObject(element) {
  const rect = element.getBoundingClientRect();
  return {
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    width: rect.width,
    height: rect.height,
    x: rect.x,
    y: rect.y,
  };
}

export function transformJsError(error) {
  if (error && error.stack && error.message) {
    return new ErrorLog(error.message, error.stack);
  }
  if (error && error.error) {
    return error;
  }

  return null;
}

export function transformAPIError(error) {
  if (error && error.stack && error.message) { // JS error
    return new APIError(error.message, error.stack);
  }
  if (error && error.error) {
    return error;
  }

  return null;
}

export function convertToTimeString(timeSecs) {
  if (timeSecs >= 0) {
    const h = Math.floor(timeSecs.toFixed(0) / 60);
    const hPad = h < 10 ? '0' : '';

    const s = timeSecs.toFixed(0) - Math.floor(timeSecs.toFixed(0) / 60) * 60;
    const sPad = s < 10 ? '0' : '';

    return hPad + h + ':' + sPad + s;
  }

  return '--:--';
}

export function convertToCountdownString(distance) {
  if (distance >= 0) {
    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (60 * 60 * 24));
    const hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((distance % (60 * 60)) / (60));

    return (
      (days === 0 ? '' : days + 'd ')
      + hours + 'h '
      + minutes + 'm '
    );
  }

  return '--:--';
}

export const percentageValueFromString = (stringValue, decimals = 1) => {
  if (!stringValue) {
    return stringValue;
  }
  if (!(typeof stringValue === 'string' && stringValue.includes('/'))) {
    return stringValue;
  }

  const valuesArray = stringValue.split('/');
  const divisor = valuesArray.pop();
  let valuePercentage = (
    Math.round(((valuesArray[0] / divisor) * 100) * (10 ** decimals)) / (10 ** decimals)
  );

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(valuePercentage)) {
    valuePercentage = 0;
  }
  return valuePercentage;
};
